import { render, staticRenderFns } from "./DetailDataProject.vue?vue&type=template&id=104a782f&scoped=true"
import script from "./DetailDataProject.vue?vue&type=script&lang=js"
export * from "./DetailDataProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104a782f",
  null
  
)

export default component.exports